module.exports = __webpack_public_path__ + "images/marketing/pipelinedeals-casestudy-8thlight.pdf";